// extracted by mini-css-extract-plugin
module.exports = {"dealer":"Dealer-module_dealer__Yyb6i","image":"Dealer-module_image__OqbpK","name":"Dealer-module_name__2SxXz"};